module.exports = __webpack_public_path__ + "img/fan.73d793cc.png";